import { createRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { Route as RootRoute } from './__root';

const LeasingDetail = lazy(() =>
  import('@/modules/leasing/LeasingDetail').then((m) => ({ default: m.LeasingDetail })),
);

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/leasing/$id',
  component: () => (
    <Suspense fallback={null}>
      <LeasingDetail />
    </Suspense>
  ),
});
